import styled from 'styled-components';

const CustomTextWrapper = styled.div`
    margin-top: 5px;
    height: 234px;
`;
CustomTextWrapper.displayName = 'CustomTextWrapper';

export default CustomTextWrapper;
